export interface OnlineApplicationForm {
  full_name: string
  father_name: string
  whatsapp_number: string
  email: string
  campus_unit_id: string
  faculty_id: string
  comments: string
}

export const initialValues: OnlineApplicationForm = {
  full_name: '',
  father_name: '',
  whatsapp_number: '',
  email: '',
  campus_unit_id: '',
  faculty_id: '',
  comments: '',
}
